<template>
  <div>
    <h1 class="page-title">Assessment Recordings</h1>
    <div class="row">
      <div class="small-12 columns" style="background-color:blue;">
        <table style="width:100%;">
          <thead>
            <tr>
              <th>COHORT</th>
              <th>USER EMAIL</th>

              <th>ASSIGNMENT NAME</th>
              <th>STATUS</th>
              <th>
                SCORE<br /><span style="font-size:13px;">scored/max score</span>
              </th>
              <th>TIMESTAMP</th>
              <th>DURATION</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(video, i) in videoLinks" :key="i">
              <td>{{ video.cohort_name }}</td>
              <td>{{ video.email }}</td>
              <td>{{ video.assignment_name }}</td>
              <td>{{ video.status }}</td>
              <td>{{ `${video.scored}/${video.max_score}` }}</td>
              <td>
                {{
                  `${new Date(video.timestamp).toDateString()} at 
                    ${new Date(video.timestamp).toLocaleTimeString()}`
                }}
              </td>
              <td>{{ getDuration(video.links.length) }}</td>
              <td>
                <span class="play-button" @click="openVideoModel(video)"
                  >Play</span
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="loading" class="loader">Loading...</div>
    <div class="video-model" :class="{ 'show-video-model': showVideoModel }">
      <div class="small-12 columns">
        <video class="video-player" controls></video>
        <div>
          <input
            v-model="playBackSpeed"
            class="slider"
            type="range"
            min="1"
            max="10"
            step="1"
            value="1"
            @change="updatePlayBackSpeed"
          />
          <span>{{ playBackSpeed }}</span>
        </div>
        <div class="close-button" @click="closeVideoModel"><span>X</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      videoLinks: [],
      showVideoModel: false,
      openedVideo: {},
      skip: 0,
      limit: 3,
      loading: true,
      playBackSpeed: 1,
    }
  },
  mounted() {
    this.getVideoLinks(this.limit, this.skip)
  },
  methods: {
    getVideoLinks(limit, skip) {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}assignments/s3/videos?limit=${limit}&skip=${skip}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.videoLinks = this.videoLinks.concat(res.data.videos)

        if (res.data.videos.length === 0) {
          this.loading = false
          return
        }
        this.getVideoLinks(limit, skip + limit)
      })
    },
    getDuration(length) {
      // we are recording every 10 seconds
      // so every chunk is of 10 seconds length
      const total_seconds = length * 10

      const hours = Math.floor(total_seconds / 3600)
      const minutes = Math.floor((total_seconds % 3600) / 60)
      const seconds = total_seconds % 60
      const formated_hours = hours > 9 ? hours : `0${hours}`
      const formated_minutes = minutes > 9 ? minutes : `0${minutes}`
      const formated_seconds = seconds > 9 ? seconds : `0${seconds}`
      return `${formated_hours}:${formated_minutes}:${formated_seconds}`
    },
    updatePlayBackSpeed() {
      const video = document.querySelector("video")
      video.playbackRate = this.playBackSpeed
    },
    openVideoModel(video) {
      this.showVideoModel = true
      this.openedVideo = { ...video }
      this.streamVideoChunks(this.openedVideo.links)
    },
    closeVideoModel() {
      this.showVideoModel = false
      this.openedVideo = {}
      this.playBackSpeed = 1
      const video = document.querySelector("video")
      video.src = null
    },
    /* eslint-disable no-unused-vars */
    /* eslint-disable no-await-in-loop */
    streamVideoChunks(chunks) {
      const FILES = Array.from(chunks)
      const blobList = []
      const video = document.querySelector("video")
      let gCurrentTime = 0
      let playedBlobListLength = 0

      const playNew = () => {
        gCurrentTime = video.currentTime
        const thisBlob = new Blob(blobList, { type: "video/webm" })
        playedBlobListLength = blobList.length
        const url = URL.createObjectURL(thisBlob)
        video.src = url
        video.playbackRate = this.playBackSpeed
        video.currentTime = gCurrentTime
        video.play().catch(() => video.pause())
      }

      video.onended = () => {
        if (playedBlobListLength !== blobList.length) {
          playNew()
        }
      }

      async function fetchFile(url) {
        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.arrayBuffer())
            .then(arrayBuffer => {
              blobList.push(new Uint8Array(arrayBuffer))
              resolve()
            })
        })
      }

      const fetchAll = async () => {
        const count = 0
        let isFirst = true
        while (FILES.length && this.showVideoModel) {
          const file = await fetchFile(FILES.shift())
          if (isFirst) {
            playNew()
            isFirst = false
          }
        }
      }
      fetchAll()
    },
  },
}
</script>

<style scoped>
table {
  background-color: #841111;
}
th {
  text-align: center;
}
.page-title {
  text-align: center;
}
.play-button {
  padding: 5px 30px;
  border-radius: 15px;
  color: #536dfa;
  background: #fff;
  cursor: pointer;
  transition: 0.3s ease-out;
}
.play-button:hover {
  color: white;
  background: #536dfa;
}
.video-model {
  visibility: hidden;
  position: fixed;
  z-index: 9999999;
  top: 10%;
  left: 10%;
  width: 80%;
  min-height: 400px;
  padding: 30px;
  opacity: 0;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.3);
  text-align: center;
  transition: opacity 0.3s ease-in-out;
}
.show-video-model {
  visibility: visible;
  opacity: 1;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  border: 1px solid red;
  border-radius: 50%;
  color: red;
  line-height: 40px;
  cursor: pointer;
  transition: all 0.35s ease-in-out;
}
.close-button:hover {
  color: #ffffff;
  background-color: red;
}
.video-player {
  width: 60%;
}
.loader {
  text-align: center;
}
.slider {
  width: 50%;
}
</style>
